/* Beautify-inspired FAQ section: animated accordion with one-open-at-a-time,
   deep-link support (#anchor opens + scrolls to a question), and editor sync. */
(function () {
  if (window.ckFaqLoaded) return;
  window.ckFaqLoaded = true;

  var MOTION_OK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function expand(item, panel) {
    item.classList.add('is-open');
    var btn = item.querySelector('[data-ck-faq-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (!MOTION_OK || panel.scrollHeight === 0) {
      panel.style.maxHeight = 'none';
      return;
    }
    panel.style.maxHeight = panel.scrollHeight + 'px';
    var done = function (event) {
      if (event.target !== panel) return;
      panel.removeEventListener('transitionend', done);
      if (item.classList.contains('is-open')) {
        panel.style.maxHeight = 'none';
      }
    };
    panel.addEventListener('transitionend', done);
  }

  function collapse(item, panel) {
    item.classList.remove('is-open');
    var btn = item.querySelector('[data-ck-faq-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (!MOTION_OK) {
      panel.style.maxHeight = '';
      return;
    }
    if (panel.style.maxHeight === 'none' || panel.style.maxHeight === '') {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      void panel.offsetHeight;
    }
    panel.style.maxHeight = '0px';
  }

  function toggleItem(item, forceOpen) {
    var section = item.closest('[data-ck-faq]');
    var panel = item.querySelector('.ck-faq__a');
    if (!panel) return;
    var isOpen = item.classList.contains('is-open');
    if (isOpen && !forceOpen) {
      collapse(item, panel);
      return;
    }
    if (isOpen) return;
    if (section && section.getAttribute('data-single') === 'true') {
      section.querySelectorAll('.ck-faq__item.is-open').forEach(function (open) {
        var openPanel = open.querySelector('.ck-faq__a');
        if (openPanel) collapse(open, openPanel);
      });
    }
    expand(item, panel);
  }

  function openFromHash() {
    if (!location.hash || location.hash.length < 2) return;
    var id;
    try {
      id = decodeURIComponent(location.hash.slice(1));
    } catch (err) {
      return;
    }
    var target = document.getElementById(id);
    if (!target) return;
    var item = target.closest ? target.closest('.ck-faq__item') : null;
    if (!item) return;
    toggleItem(item, true);
    var delay = MOTION_OK ? 350 : 0;
    setTimeout(function () {
      item.scrollIntoView({ behavior: MOTION_OK ? 'smooth' : 'auto', block: 'start' });
    }, delay);
  }

  function initSection(section) {
    if (section.dataset.ckFaqInit === 'true') return;
    section.dataset.ckFaqInit = 'true';

    section.querySelectorAll('[data-ck-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ck-faq__item');
        if (item) toggleItem(item);
      });
    });

    // "Open first question" render state: give it a free height.
    section.querySelectorAll('.ck-faq__item.is-open .ck-faq__a').forEach(function (panel) {
      panel.style.maxHeight = 'none';
    });
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll('[data-ck-faq]');
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      openFromHash();
    });
  } else {
    initAll(document);
    openFromHash();
  }

  window.addEventListener('hashchange', openFromHash);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest ? event.target.closest('.ck-faq__item') : null;
    if (item && !item.classList.contains('is-open')) toggleItem(item, true);
  });
})();
